import React from "react";
import {debug} from "../utils";
import {connect} from "react-redux";
import {CheckboxTable} from "../view/CheckboxTable";
import {useViolationsTableHelper} from "./useViolationsTableHelper";
import ViolationsTableRow from "./ViolationsTableRow";

function ViolationsTable({violations}) {

    const helper = useViolationsTableHelper();

    const headers = [
        {name: 'RULE NAME', sortKey: 'rule', onClick: () => helper.onRuleNameClick()},
        {name: 'DESCRIPTION', sortKey: 'details', onClick: () => helper.onDetailsClick()},
        {name: 'EXPECTED RESULT', sortKey: 'expectedOutput', onClick: () => helper.onExpectedResultClick()},
        {name: 'USER', sortKey: 'user', onClick: () => helper.onUserClick()},
        {name: 'SEVERITY', sortKey: 'severity', onClick: () => helper.onSeverityClick()},
        {name: 'VALID', sortKey: 'valid', onClick: () => helper.onValidClick()},
        {name: 'DEVICE', sortKey: 'device', onClick: () => helper.onDeviceClick()},
        {name: 'GROUP', onClick: () => helper.onGroupClick()},
    ]

    return (
        <CheckboxTable headers={headers} elements={violations}>
            {violations.map((data, index) => <ViolationsTableRow key={index} data={data} index={index}/>)}
        </CheckboxTable>
    );
}

function mapStateToProps(state) {
    debug("ValidateTable mapStateToProps", state);
    const violationsPage = state.violationsPage;
    return {
        violations: violationsPage.violations || []
    };
}

export default connect(mapStateToProps)(ViolationsTable);
